var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15632 10.3683V3.96883C5.15566 3.85503 5.1889 3.74362 5.25181 3.64879C5.31471 3.55396 5.40444 3.48001 5.50953 3.43637C5.61463 3.39274 5.73035 3.38139 5.84192 3.40377C5.95349 3.42615 6.05588 3.48126 6.13601 3.56206L9.33289 6.76466C9.4396 6.872 9.49949 7.01721 9.49949 7.16857C9.49949 7.31992 9.4396 7.46513 9.33289 7.57247L6.13601 10.7751C6.05588 10.8559 5.95349 10.911 5.84192 10.9334C5.73035 10.9557 5.61463 10.9444 5.50953 10.9008C5.40444 10.8571 5.31471 10.7832 5.25181 10.6883C5.1889 10.5935 5.15566 10.4821 5.15632 10.3683Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caretRight.3860c76270f44bee04a1a5687af46384.svg";
export { ForwardRef as ReactComponent };